import { useCallback, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import classApi from "../../api/classApi";
import sessionApi from "../../api/sessionApi";
import { formatHourAndDate } from "../../common";
import Button from "../../components/Button";
import ConnectGooglePopup from "../../components/ConnectGooglePopup";
import CreateSessionPopup from "../../components/CreateSessionPopup";
import Layout from "../../components/Layout";
import NavigateSession from "../../components/NavigateSession";
import Title from "../../components/Title";
import { RootState } from "../../store";

export default function ClassDetail() {
    const { id } = useParams();
    const [data, setData] = useState<any>();
    const { user } = useSelector((state: RootState) => state.auth);
    const isStudent = user?.roles.includes("Học viên") || user?.roles.includes("student");

    const fetchClassData = useCallback(async () => {
        const res = await classApi.getClassById(Number(id));
        console.log("Class detail data", res.data.meetingLink);
        setData(res.data);
    }, [id]);

    useEffect(() => {
        fetchClassData();
    }, [id, fetchClassData]);

    const handleCoppyLink = () => {
        if (data?.meetingLink) {
            navigator.clipboard.writeText(data.meetingLink);
            toast.success("Đã sao chép thành công!");
        }
    }

    const handleCreateLinkMeeting = async () => {
        if (!user) return;
        console.log("User info", user);
        if (user?.studentManagement?.isConnectGoogle) {
            setIsOpen(true);
        } else {
            setShow(true);
        }
    }
    const [show, setShow] = useState(false);
    const handleClosePopup = () => {
        setShow(false);
    };

    const handleOpenCreateMeeting = () => {
        setIsOpen(true);
    }

    const [isOpen, setIsOpen] = useState(false);

    const handleCloseSessionPopup = () => {
        setIsOpen(false);
    }

    const handleCreateSessionSuccess = () => {
        toast.success("Tạo buổi học thành công");
        fetchClassData();   // nếu cần update info lớp
        fetchSessions();    // ✅ reload lại số buổi học
    };


    const [sessions, setSessions] = useState<any[]>([]);

    const fetchSessions = useCallback(async () => {
        const params = { page: 1, classId: Number(id) };
        const res = await sessionApi.getSessionByClassId(params);
        console.log("Session data", res.data.items);
        setSessions(res.data.items);
    }, [id]);

    useEffect(() => {
        fetchSessions();
    }, [fetchSessions]);

    const [sessionDetail, setSessionDetail] = useState<any>();
    const handleGetSessionData = useCallback(async (sessionId: number) => {
        const res = await sessionApi.getSessionById(sessionId);
        console.log("Session detail data", res.data);
        setSessionDetail(res.data);
    }, []);
    return (
        <Layout>
            {isOpen && <CreateSessionPopup onSuccess={handleCreateSessionSuccess} classId={id} open={isOpen} onClose={handleCloseSessionPopup} />}
            {show && <ConnectGooglePopup
                onClose={handleClosePopup}
                onCancel={handleClosePopup}
                onSuccess={handleOpenCreateMeeting}
            />}
            <section className="w-full h-fit py-[60px] px-[20px] lg:px-[50px] text-center bg-light">
                <Title title="Thông Tin Lớp Học" subTitle={`Thông tin chi tiết về lớp học`} />
                <div className="mt-[40px]">
                    <div className="bg-white p-[40px] rounded-[10px] shadow-md">
                        <h1 className="text-secondary text-[24px] font-bold uppercase text-center mb-[40px]"><span className="">Tên lớp: </span><span>{data?.title}</span></h1>
                        <div className="flex flex-wrap justify-between gap-y-[20px] text-left">
                            <div className="w-1/3 flex flex-col justify-center items-start">
                                <p>Tên giáo viên:</p>
                                <span className="font-bold italic">{data?.teacher.name}</span>
                            </div>
                            <div className="w-1/3 flex flex-col justify-center items-start">
                                <span className="text-[16px]">Link học trực tuyến: </span>
                                <div>
                                    <a className="text-secondary font-bold" href={
                                        `${data?.meetingLink}`
                                    } target="_blank" rel="noopener noreferrer"
                                    >{data?.meetingLink}</a>
                                    <i onClick={handleCoppyLink} className="fa fa-link ml-[10px] text-secondary cursor-pointer"></i>
                                </div>
                            </div>
                            <div className="w-1/3 flex flex-col justify-center items-start">
                                <p>Tổng số học viên:</p>
                                <span className="font-bold">{data?.students.length} học viên</span>
                            </div>
                        </div>
                        {!isStudent && (<div className="flex justify-end mt-[40px]">
                            <Button label="+ Tạo buổi học" onClick={handleCreateLinkMeeting} />
                        </div>)}
                    </div>
                    <div className="mt-[40px] bg-white p-[40px] rounded-[10px] shadow-md">
                        <h2 className="font-bold mb-[40px] text-center text-[20px] text-secondary">Danh sách học viên</h2>
                        <div className="flex flex-col">
                            <div className="flex divide-x-[2px] divide-gray-300 justify-between border-b-[2px] border-gray-200 pb-[4px]">
                                <span className="w-2/12 text-center font-bold">ID</span>
                                <span className="w-5/12 text-center font-bold">Tên học sinh</span>
                                <span className="w-5/12 text-center font-bold">Email</span>
                            </div>
                            <div className="flex flex-col mt-[10px]">
                                {data?.students.length > 0 && data.students.map((student: any) => (
                                    <div key={student.id} className="border-b border-gray-300 py-[10px] flex">
                                        <span className="w-2/12 text-center">{student.id}</span>
                                        <span className="w-5/12 text-center">{student.fullName}</span>
                                        <span className="w-5/12 text-cente">{student.email}</span>
                                    </div>
                                )
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="mt-[40px] bg-white p-[40px] rounded-[10px] shadow-md">
                        <h2 className="font-bold mb-[40px] text-center text-[20px] text-secondary">Danh sách buổi học</h2>
                        {<div className="flex min-h-[300px]">
                            <div className="w-[10%] min-h-[300px]">
                                <NavigateSession data={sessions} onGetIdSession={(data) => handleGetSessionData(data)} />
                            </div>
                            <div className="w-[90%] border border-[#e0e0e0] rounded-[10px] p-[20px] ml-[20px]">
                                {sessionDetail && (
                                    <div>
                                        <h2 className="text-secondary text-[20px] text-center font-bold">{sessionDetail.title}</h2>
                                        <div className="flex items-start flex-col pl-[20px]">
                                            <p className="mt-[20px]"><span className="font-bold ml-[20px]">Mô tả: </span><span>{sessionDetail.description}</span></p>
                                            <p className="mt-[20px]"><span className="font-bold ml-[20px]">Link học: </span><a className="text-secondary font-bold" target="_blank" href={`${sessionDetail.meetingLink}`} rel="noopener noreferrer"
                                            >{sessionDetail.meetingLink}</a></p>
                                            <p className="mt-[20px]"><span className="font-bold ml-[20px]">Thời gian bắt đầu: </span><span>{formatHourAndDate(sessionDetail.startTime)}</span></p>
                                            <p className="mt-[20px]"><span className="font-bold ml-[20px]">Thời gian kết thúc: </span><span>{formatHourAndDate(sessionDetail.endTime)}</span></p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>}
                    </div>
                </div>
            </section>
        </Layout>
    )
};